import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, ShieldCheckIcon, WifiIcon, KeyRoundIcon, SmartphoneIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-2400" data-mp="3l3gmkaz24opf">
      {/* Header with logo */}
      <header className="w-full bg-white border-b border-gray-100 px-5 py-3" data-id="element-2401" data-mp="3pxb4p9z0kvme">
        <div className="max-w-md mx-auto flex items-center justify-center" data-id="element-2402" data-mp="3utrvyd1ifq3p">
          <Link to="/" className="flex-shrink-0" data-id="element-2403" data-mp="3o0fy6hg5tum">
            <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo" className="h-6" data-id="element-2404" data-mp="3mp4rllo9jth" />
          </Link>
        </div>
      </header>

      {/* Main content */}
      <div className="px-5 pt-4 pb-6 flex-1 flex flex-col" data-id="element-2405" data-mp="2afrkpqav45dm">
        <div className="max-w-md mx-auto flex flex-col items-center text-center flex-1" data-id="element-2406" data-mp="2ahca71ibky4m">
          {/* Heading */}
          <h1 className="text-[1.75rem] md:text-[2.25rem] font-semibold text-[#111111] leading-[1.15] tracking-tight mb-1" data-id="element-2407" data-mp="3sqq3q0ub5a36">
            Digital Safety Check
          </h1>
          <p className="text-sm md:text-base text-gray-500 leading-relaxed mb-4" data-id="element-2408" data-mp="3ny6rp8b9qn0h">
            Get a personalized action plan in 3-4 minutes.
          </p>

          {/* Three-step process */}
          <div className="flex items-center justify-center mb-5" data-id="element-2409" data-mp="3dzzaqpgzc4yh">
            <div className="flex flex-col items-center" data-id="element-2410" data-mp="fj54fxn2ax6j">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-2411" data-mp="almsdydr01ub">
                <ClipboardCheckIcon size={18} className="text-gray-400" data-id="element-2412" data-mp="5lh6yzy2nbko" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-2413" data-mp="np8fn2x8r7i">
                Assess
              </span>
            </div>

            <div className="w-8 md:w-12 h-[2px] bg-gray-200 mb-4" data-id="element-2414" data-mp="2qe2heun5h9yn" />

            <div className="flex flex-col items-center" data-id="element-2415" data-mp="2ld50smhsgnz9">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-2416" data-mp="2lfr9ipgf19j2">
                <BookOpenIcon size={18} className="text-gray-400" data-id="element-2417" data-mp="1hg2qjdx6jvtw" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-2418" data-mp="13frw60wnvz3z">
                Plan
              </span>
            </div>

            <div className="w-8 md:w-12 h-[2px] bg-gray-200 mb-4" data-id="element-2419" data-mp="18dtj4wx7kikq" />

            <div className="flex flex-col items-center" data-id="element-2420" data-mp="tq8e2xgrw9a6">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-2421" data-mp="tooyza6us49z">
                <ShieldCheckIcon size={18} className="text-gray-400" data-id="element-2422" data-mp="kpa8wbullvq0" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-2423" data-mp="kngzwpwiizeu">
                Act
              </span>
            </div>
          </div>

          {/* What we'll cover label */}
          <p className="text-[#631bb7] text-sm mb-3 font-medium" data-id="element-2424" data-mp="at76r5zqxx32">
            Here's what we'll cover:
          </p>

          {/* What's Covered */}
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-2425" data-mp="3s91h7vy3zhmq">
            <div className="flex px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm items-center justify-center" data-id="element-2426" data-mp="3o87tp3okw4ud">
              <span className="text-lg flex-shrink-0" data-id="element-2427" data-mp="62v1q48v61sh">🏠</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-2428" data-mp="608n5knk2m0r">
                Home Network
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-2429" data-mp="f1q93jnn9hxd">
              <span className="text-lg flex-shrink-0" data-id="element-2430" data-mp="b1fs7bybd73q">🔐</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-2431" data-mp="otchl88ll2wf">
                Passwords
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-2432" data-mp="jwcb4w7u5y4s">
              <span className="text-lg flex-shrink-0" data-id="element-2433" data-mp="ts5scswi2fsw">📱</span>
              <span className="ml-1.5 text-[#111111] whitespace-nowrap text-xs font-medium" data-id="element-2434" data-mp="tu0iqmqjj04d">
                Devices
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-2435" data-mp="2s9hji6l0witp">
              <span className="text-lg flex-shrink-0" data-id="element-2436" data-mp="2x1r2f2nq0imh">🛡️</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-2437" data-mp="31zsugd34jsa3">
                Data & Privacy
              </span>
            </div>
          </div>

          <div className="mt-auto w-full pt-4" data-id="element-2438" data-mp="24e51k25vns3b">
            {/* Start Assessment button */}
            <Link to="/assessment" className="block w-full bg-[#631bb7] text-white px-6 py-3.5 rounded-xl font-medium text-base no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-2439" data-mp="29bdgzuzn5i0v">
              Start Assessment
            </Link>
          </div>
        </div>
      </div>
    </div>;
}